import {
  SmallGroupActivityPlan,
  SmallGroupPlanItem,
} from '../../../types/smallGroup';
import ApprovalStampBox from '../ApprovalStampBox';
import '../../quality/EducationAnnualPlanTab.css';
import '../../quality/QualityShell.css';
import '../../quality/SmallGroupPanel.css';
import '../../product/InspectionFormSheet.css';
import '../../product/NonconformanceReportPanel.css';

interface Props {
  detail: SmallGroupActivityPlan;
}

function newId() {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
}

function parsePlanItems(json?: string | null): SmallGroupPlanItem[] {
  if (!json?.trim()) return [];
  try {
    const parsed = JSON.parse(json);
    if (!Array.isArray(parsed)) return [];
    return parsed.map((row: Partial<SmallGroupPlanItem>) => ({
      id: row.id || newId(),
      topic: row.topic || '',
      schedule: row.schedule || '',
      method: row.method || '',
      owner: row.owner || '',
    }));
  } catch {
    return [];
  }
}

function SmallGroupPlanPreviewView({ detail }: Props) {
  const items = parsePlanItems(detail.itemsJson);

  return (
    <div className="quality-form">
      <section className="quality-form__section">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 16,
            alignItems: 'flex-start',
            marginBottom: 12,
          }}
        >
          <h3 style={{ margin: 0 }}>활동 계획서</h3>
          <ApprovalStampBox
            authorName={detail.authorName}
            reviewerName={detail.reviewerName}
            approverName={detail.approverName}
          />
        </div>
        <div className="quality-form__grid">
          <label>
            계획서번호
            <input readOnly value={detail.planNo || ''} />
          </label>
          <label>
            소집단 *
            <input readOnly value={detail.groupName || '-'} />
          </label>
          <label>
            연도
            <input type="number" readOnly value={detail.planYear ?? ''} />
          </label>
          <label className="is-span-2">
            제목
            <input readOnly value={detail.title || ''} />
          </label>
          <label>
            기간 시작
            <input type="date" readOnly value={detail.periodFrom || ''} />
          </label>
          <label>
            기간 종료
            <input type="date" readOnly value={detail.periodTo || ''} />
          </label>
          <label>
            작성자
            <input readOnly value={detail.preparedBy || ''} />
          </label>
          <label className="is-span-2">
            목표
            <textarea rows={3} readOnly value={detail.objective || ''} />
          </label>
          <label className="is-span-2">
            기대효과
            <textarea rows={2} readOnly value={detail.expectedEffect || ''} />
          </label>
        </div>

        <div style={{ marginTop: 16 }}>
          <div style={{ marginBottom: 8 }}>
            <strong>활동 항목</strong>
            <p className="quality-form__hint" style={{ margin: '4px 0 0' }}>
              {items.length}건
            </p>
          </div>
          <div className="edu-plan-table-wrap sg-plan-items-wrap">
            <table className="edu-plan-table sg-plan-items-table">
              <thead>
                <tr>
                  <th className="col-no">No</th>
                  <th className="col-topic">주제/활동</th>
                  <th className="col-schedule">시기</th>
                  <th className="col-method">방법</th>
                  <th className="col-owner">담당</th>
                </tr>
              </thead>
              <tbody>
                {items.length === 0 ? (
                  <tr>
                    <td colSpan={5} className="sg-plan-items-empty">
                      등록된 활동 항목이 없습니다.
                    </td>
                  </tr>
                ) : (
                  items.map((item, idx) => (
                    <tr key={item.id}>
                      <td className="is-center col-no">{idx + 1}</td>
                      <td className="col-topic">
                        <input readOnly value={item.topic} />
                      </td>
                      <td className="col-schedule">
                        <input readOnly value={item.schedule} />
                      </td>
                      <td className="col-method">
                        <input readOnly value={item.method} />
                      </td>
                      <td className="col-owner">
                        <input readOnly value={item.owner} />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="quality-form__grid" style={{ marginTop: 12 }}>
          <label className="is-span-2">
            비고
            <textarea rows={2} readOnly value={detail.remark || ''} />
          </label>
        </div>
      </section>
    </div>
  );
}

export default SmallGroupPlanPreviewView;
